import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {ServiceWorkerSettingsConfig} from 'interfaces/shared/serviceworker/serviceWorkerSettingsConfig';

export const initServiceWorker = (gemSettings: GemSettings) => () => {
    const config = getGemSettingsFeature<ServiceWorkerSettingsConfig>(gemSettings, 'sw');
    if (gemSettings.author || !config) {
        return;
    }

    let swPath = '/content/sw.js';
    const options: RegistrationOptions = {};
    if (gemSettings.environment !== 'LOCAL') {
        swPath = config.path;
        options.scope = config.scope;
    }

    navigator.serviceWorker
        .register(swPath, options)
        .then((registration) => {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        })
        .catch((err) => {
            console.log('ServiceWorker registration failed: ', err);
        });
};
